import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "src/services";
import { is } from "src/util/is";

// Peak-hour heatmap (7x24 intensity grid) for the dashboard.
export const usePeakHourHeatmap = ({ teamId, timeRange = "30d", enabled = true }) =>
  useQuery({
    queryKey: ["getPeakHourHeatmap", teamId, timeRange],
    queryFn: () => dashboardService.getPeakHourHeatmap(teamId, timeRange),
    enabled: !is.empty(teamId) && enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
